export default {
    methods: {
        formattedImgUrl(url) {
          if (url.match(/(<img([^>]+)>)/gi) != null) {
            let temp = url.match(/(<img([^>]+)>)/gi);
            return (temp[0].substring(temp[0].indexOf("https"), temp[0].indexOf('g"')).replace() + "g");
          } else {
            return "";
          }
        },
    
        formattedTimestamp(timestamp) {
          return timestamp.substring(0, 10);
        },
    
        formattedCategory(category) {
          let cate = "";
          if (category.indexOf("learning") != -1) cate += "學習投入 ";
          if (category.indexOf("core") != -1) cate += "核心能力 ";
          if (category.indexOf("cooperation") != -1) cate += "處室合作";
          if (category.indexOf("other") != -1) cate += "校務議題 ";
          return cate;
        }
    }
}